import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import envVars from '../../../constants/envVars';
import { useUserStatusContext } from '../../../context/UserStatus';
import useRequest from '../../../hooks/useRequest';
import { CareManager } from '../types';
import { CARE_MANAGERS_KEY } from './constants';

const useGetCareManagers = () => {
    const req = useRequest();
    const { permissions } = useUserStatusContext();

    // Gate strictly on the Care Manager module VIEW bit (HWM-23020): the rtm-api
    // care-managers endpoint requires ENT_CARE_MANAGER_VIEW, which only Care Manager,
    // Care Manager Supervisor and Admin hold. Hero Standard / Hero Read Only have
    // fleetMemberView but NOT this bit, so gating on fleetMemberView fired a request they
    // are forbidden to make → 403 → auto-logout. Not calling it at all for those roles.
    const canSeeCareManagers = permissions.careManager.careManagerView;

    const action = useCallback(() => {
        return req<CareManager[]>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/care-managers/`
        });
    }, [req]);

    return useQuery({
        queryFn: action,
        queryKey: [CARE_MANAGERS_KEY],
        enabled: canSeeCareManagers
    });
};

export default useGetCareManagers;
